module.exports = {
  chat: 'Chat',
  message: {
    userEnteredRoom: 'has entered the room',
    userLeftRoom: 'has left the room',
    jackpotAlert: 'JACKPOTT',
    freeGameWinnerAlert: 'JACKPOTT VINST',
    arcadeWinnerAlert: 'TOPPVINST'
  },
  actions: {
    roomSwap: 'swap',
    toggleUserList: 'users',
    toggleChatFreeze: 'freeze',
    toggleStealthMode: 'stealth',
    toggleEnterAndExitMessages: 'enter'
  },
  contextMenu: {
    profile: 'Profile',
    pay: 'Pay',
    sin: 'Sin',
    ban: 'Ban',
    search: 'Search',
    promoPrize: 'Award Promo',
    safeplayReferral: 'Safeplay Referral',
    playerNotes: 'Player Notes',
    technicalIssueReferral: 'Technical Issue Referral',
    userNomination: 'Nominate'
  },
  roomSwap: {
    menuTitle: 'Room Swap'
  },
  profile: {
    title: 'Profile',
    confirm: null,
    success: 'User {username} is viewable.',
    failed: 'User {username} profile can not be viewed.',
    birthday: 'Today is the user\'s birthday',
    returningAfterLapsing: 'Player has returned after lapsing',
    newMember: 'Player is new to the site',
    notEligibleForChatPrize: 'User {username} is a young adult and not eligible for bonuses',
    chatPrize: 'Bling! player has maxed out on quizzes',
    returnedFromExclusion: 'Player has recently returned from exlusion',
    twiceSinned: 'Player has been sinned twice today',
    copyClipboardSuccess: 'User information copied to clipboard',
    profileUsername: 'User Profile for',
    device: {
      game: 'Game',
      platform: 'Platform',
      platform_version: 'Platform Version',
      os: 'OS',
      browser: 'Browser'
    }
  },
  clientType: {
    unknown: 'unknown',
    '11': { platform: 'Windows', type: 'Flash plugin' },
    '12': { platform: 'Mac', type: 'Flash plugin' },
    '13': { platform: 'Linux', type: 'Flash plugin' },
    '14': { platform: 'Android', type: 'Flash plugin' },
    '15': { platform: 'Playstation 3', type: 'Flash plugin' },
    '16': { platform: 'RIM (Playbook)', type: 'Flash plugin' },
    '17': { platform: 'Unknown', type: 'Flash plugin' },
    '18': { platform: 'Other', type: 'Flash plugin' },
    '25': { platform: 'Unknown', type: 'HTML5 App' },
    '21xxx': { platform: 'Android', type: 'HTML5 App' },
    '22xxx': { platform: 'iOS', type: 'HTML5 App' },
    '23xxx': { platform: 'Windows', type: 'HTML5 App' },
    '24xxx': { platform: 'Blackberry', type: 'HTML5 App' },
    '25xxx': { platform: 'Playbook', type: 'HTML5 App' },
    '29xxx': { platform: 'Other', type: 'HTML5 App' },
    '31xxx': { platform: 'Mobile Android', type: 'Native App' },
    '32xxx': { platform: 'Mobile iOS', type: 'Native App' },
    '33xxx': { platform: 'Mobile Windows', type: 'Native App' },
    '34xxx': { platform: 'Mobile Blackberry', type: 'Native App' },
    '39xxx': { platform: 'Mobile Other', type: 'Native App' },
    '41xxx': { platform: 'Tablet Android', type: 'Native App' },
    '42xxx': { platform: 'Tablet iOS', type: 'Native App' },
    '43xxx': { platform: 'Tablet Windows', type: 'Native App' },
    '44xxx': { platform: 'Tablet Blackberry', type: 'Native App' },
    '49xxx': { platform: 'Tablet Other', type: 'Native App' },
    '50xxx': { platform: 'MacOS Chrome', type: 'HTML5 desktop client' },
    '51xxx': { platform: 'MacOS Safari', type: 'HTML5 desktop client' },
    '52xxx': { platform: 'MacOS Firefox', type: 'HTML5 desktop client' },
    '53xxx': { platform: 'MacOS Other', type: 'HTML5 desktop client' },
    '54xxx': { platform: 'Windows Chrome', type: 'HTML5 desktop client' },
    '55xxx': { platform: 'Windows IE', type: 'HTML5 desktop client' },
    '56xxx': { platform: 'Windows Firefox', type: 'HTML5 desktop client' },
    '57xxx': { platform: 'Windows Other', type: 'HTML5 desktop client' },
    '59xxx': { platform: 'Other', type: 'HTML5 desktop client' },
    '61xxx': { platform: 'Mobile Android', type: 'Hybrid App' },
    '63xxx': { platform: 'Mobile iOS', type: 'Hybrid App' },
    '64xxx': { platform: 'Mobile Windows', type: 'Hybrid App' },
    '65xxx': { platform: 'Mobile Blackberry', type: 'Hybrid App' },
    '69xxx': { platform: 'Mobile Other', type: 'Hybrid App' },
    '71xxx': { platform: 'Tablet Android', type: 'Hybrid App' },
    '72xxx': { platform: 'Tablet iOS', type: 'Hybrid App' },
    '73xxx': { platform: 'Tablet Windows', type: 'Hybrid App' },
    '74xxx': { platform: 'Tablet Blackberry', type: 'Hybrid App' },
    '79xxx': { platform: 'Tablet Other', type: 'Hybrid App' }
  },
  sin: {
    title: 'Sin Bin',
    confirm: 'Are you sure that you want to sin-bin user \'{username}\'?',
    success: 'User {username} has been sin-binned.',
    failed: 'User {username} has not been sin-binned.',
    notification: '{username} has received a sin-bin.',
    reason: 'Please provide a reason why \'{username}\' has been sin-binned.'
  },
  playernotes: {
    deletetitle: 'Delete this note?',
    deletetext: 'Are you sure you wish to delete this note ({noteSummary})?',
    deleteerrortitle: 'Unable to delete note',
    deleteerrorconfirm: 'Unable to delete note ({noteSummary})?',
    deletebuttontext: 'Delete',
  },
  prize: {
    title: 'Award Chat Prize',
    confirm: 'Are you sure that you want to award user \'{username}\' a chat prize of {chatPrizeValue}?',
    confirmMultiple: 'Are you sure that you want to award a chat prize of {chatPrizeValue} to each of these users?',
    success: 'User {username} has been awarded a chat prize.',
    failed: 'User {username} has not been awarded a chat prize.',
    notification: '{username} has received a chat prize.',
    userValidationError: 'Chat prizes have not been awarded because the following users are not present in this chat room:<br/>{usernames}',
    prizeTitle: 'Choose Prize Amount',
    prize: 'How much do you wish to award?'
  },
  promoPrize: {
    title: 'Promotional Prize',
    success: 'User {username} has been awarded a promotional prize',
    failed: 'User {username} has not been awarded a promotional prize'
  },
  ban: {
    title: 'Ban',
    confirm: 'Are you sure that you want to ban user \'{username}\'?',
    success: 'User {username} has been banned.',
    failed: 'User {username} has not been banned.',
    notification: '{username} has received a ban.',
    reason: 'Please provide a reason why \'{username}\' has been banned.'
  },
  freeze: {
    enabled: '--- FREEZE ENABLED ---',
    disabled: '--- FREEZE DISABLED ---'
  },
  generic: {
    copyButton: 'Copy',
    reasonPlaceholder: 'Reason',
    reasonValidationError: 'Please provide a reason'
  },
  jackpot: {
    alert: '{username} har vunnit {totalPrizeValueInPounds}kr i {gameName}'
  },
  alertWords: {
    template: '<strong>{alertWords}</strong> entered into <strong>{chatRoom}</strong> by <strong>{username}</strong>',
    confirmButton: 'Show Me',
    dismissButton: 'Dismiss All'
  },
  safeplayReferral: {
    title: 'Safeplay Referral',
    input: 'Please provide evidence of {username}\'s behaviour.',
    confirm: 'Are you sure that you want to refer user \'{username}\' to the Safeplay team?',
    success: 'User {username} has been referred to the Safeplay team.',
    failed: 'User {username} has not been referred to the Safeplay team.',
    notification: '{username} has been referred to the Safeplay team.'
  },
  technicalIssueReferral: {
    title: 'Technical Issue Referral',
    success: 'A technical issue as been logged for user {username}.',
    failed: 'A technical issue has not been logged for user {username}.',
    input: 'Please provide details of {username}\'s technical issue.'
  },
  userNomination: {
    title: 'User Nomination',
    success: 'A nomination as been logged for user {username}.',
    failed: 'A nomination has not been logged for user {username}.',
    input: 'Please provide details of {username}\'s nomination.'
  }
}



//////////////////
// WEBPACK FOOTER
// ./src/plugins/localisation/languages/se/chat.js
// module id = Ssen
// module chunks = 1